import React, {useContext} from 'react';
import styled from 'styled-components';
import {
  GoogleOAuthProvider,
  GoogleLogin,
  CredentialResponse,
} from '@react-oauth/google';
import {$post, clearCsrf} from '../lib/requests';
import {useNavigate} from 'react-router-dom';
import {AuthContext, useAuthRedirects, AuthState} from '../App';

const LoginScreenContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function LoginScreen() {
  useAuthRedirects();
  const navigate = useNavigate();
  const {setAuth} = useContext(AuthContext);

  async function handleGoogleLogin(response: CredentialResponse) {
    try {
      const res = await $post<AuthState>(
        '/login',
        response as unknown as Record<string, unknown>
      );
      clearCsrf();
      if (setAuth) {
        setAuth(res);
      }
      if (res && res.unauthorised) return navigate('/401');
      if (res && res.isLoggedIn) {
        return navigate('/');
      }
    } catch (err) {
      console.error('Login request failed:', err);
    }
  }

  return (
    <GoogleOAuthProvider
      clientId={
        process.env.REACT_APP_GOOGLE_CLIENT_ID ||
        '1051633168139-9osina7da7509m5st6jqt3f2tar7luub.apps.googleusercontent.com'
      }
    >
      <LoginScreenContainer>
        <GoogleLogin
          theme="outline"
          type="standard"
          size="large"
          shape="pill"
          logo_alignment="left"
          locale="en_GB"
          ux_mode="popup"
          context="signin"
          onSuccess={handleGoogleLogin}
          onError={() => {
            console.error('Google Sign-In failed');
          }}
        />
      </LoginScreenContainer>
    </GoogleOAuthProvider>
  );
}
